import { ValueOf } from 'next/dist/shared/lib/constants'
import { GetTaskParams } from '@/shared/api/end-points/task'

export const LLMsKeys = {
  OLLAMA: 'OLLAMA',
} as const

export const LLMsValues = {
  [LLMsKeys.OLLAMA]: 'ollama',
} as const

export const LLMs = {
  [LLMsKeys.OLLAMA]: LLMsValues.OLLAMA,
} as const

export interface GetLLMMessagesParams {
  selectLLM: (props: typeof LLMs) => ValueOf<typeof LLMs>
}

export interface SendLLMMessageParams {
  selectLLM: (props: typeof LLMs) => ValueOf<typeof LLMs>
}

const endpoints = {
  getHypothesesMessages: ({ projectId, taskId }: GetTaskParams): string => {
    return `api/v2/users/user-id/projects/${projectId}/tasks/${taskId}/hypothesis/messages`
  },
  getMessages: ({ selectLLM }: GetLLMMessagesParams): string => {
    const languageModel = selectLLM(LLMs)
    return `api/v2/users/user-id/llm/${languageModel}/messages`
  },
  sendMessage: ({ selectLLM }: SendLLMMessageParams): string => {
    const languageModel = selectLLM(LLMs)
    return `api/v2/users/user-id/llm/${languageModel}/messages`
  },
}

export default endpoints
